import {
  FundingOptionsPage,
  FundingOriginInput,
} from '@varo/graphql-schema-types';
import { useEffect } from 'react';
import fundingOptionsQuery from 'services/graphql/queries/onboarding/FundingOptions.query';
import { logErrorWithContext } from 'shared/utils/sentry/sentry';
import {
  ErrorSeverity,
  FeatureArea,
  ResponsibleTeam,
} from 'shared/utils/sentry/sentry.constants';
import { useQuery } from 'urql';

const useGetFundingOptions = ({ origin }: { origin: FundingOriginInput }) => {
  const [{ data, error, fetching }] = useQuery<{
    fundingOptions: FundingOptionsPage;
  }>({
    query: fundingOptionsQuery,
    variables: {
      input: {
        origin,
      },
    },
    requestPolicy: 'network-only',
  });

  useEffect(() => {
    if (error) {
      logErrorWithContext('Funding options error from GQL: ' + error, {
        featureArea: FeatureArea.ONBOARDING,
        responsibleTeam: ResponsibleTeam.CUSTOMER_ACQUISITION,
        severity: ErrorSeverity.LOW,
      });
    }
  }, [error]);

  return {
    fundingOptionsData: data?.fundingOptions,
    error,
    fetching,
  };
};

export default useGetFundingOptions;
